
<div class="wrapper-video">
  <video id="videoPlayer" #videoPlayer class="video" ></video>
  <button class="pause-btn" (click)="handleVideo($event)" *ngIf="player && player.paused()">
    <img class="play" src="assets/images/new-design-icons/play-big.svg" alt="play" />
  </button>

  <button class="sound-button"  *ngIf="player" (click)="changeSound($event)">
    <img *ngIf="!player.muted()" src="assets/images/new-design-icons/sound.svg">
    <img *ngIf="player.muted()" src="assets/images/new-design-icons/sound-off.svg">
</button>
</div>